import cn from 'classnames'
import React, { ComponentProps } from 'react'

type IntegrationsCodeBlockIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function IntegrationsCodeBlockIcon(
  props: IntegrationsCodeBlockIconProps,
) {
  const { className = '', ...rest } = props
  return (
    <svg
      className={cn('IntegrationsCodeBlockIcon', className)}
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M23.3333 28.3333L28.3333 23.3333L23.3333 18.3333M16.6667 11.6667L11.6667 16.6667L16.6667 21.6667M13 35H27C29.8003 35 31.2004 35 32.27 34.455C33.2108 33.9757 33.9757 33.2108 34.455 32.27C35 31.2004 35 29.8003 35 27V13C35 10.1997 35 8.79961 34.455 7.73005C33.9757 6.78924 33.2108 6.02433 32.27 5.54497C31.2004 5 29.8003 5 27 5H13C10.1997 5 8.79961 5 7.73005 5.54497C6.78924 6.02433 6.02433 6.78924 5.54497 7.73005C5 8.79961 5 10.1997 5 13V27C5 29.8003 5 31.2004 5.54497 32.27C6.02433 33.2108 6.78924 33.9757 7.73005 34.455C8.79961 35 10.1997 35 13 35Z"
        stroke="currentColor"
        strokeWidth="3.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
